<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
      <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { watch, computed, onMounted } from 'vue'
import { useTheme } from '~/composables/useTheme'
import { useHead } from '#app'

const { themeName } = useTheme()

// Reactive favicon URL based on theme
const faviconHref = computed(() =>
  themeName.value === 'dark' ? '/favicon-dark.ico' : '/favicon-light.ico'
)

// Update head whenever theme changes
watch(faviconHref, (href) => {
  useHead({
    link: [
      { rel: 'icon', type: 'image/x-icon', href }
    ]
  })
}, { immediate: true }) // also sets it initially

onMounted(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('Service Worker registered successfully:', reg.scope))
      .catch(err => console.error('Service Worker registration failed:', err))
  }
})
</script>